const blockingTags = ['block_FP'];

export const isProductBlockedToUpdate = tags => {
  if (!blockingTags.length || !tags) return false;

  const regularExpresion = new RegExp(blockingTags.join('|'));

  return regularExpresion.test(tags);
};
